module.exports = __webpack_public_path__ + "assets/img/img24.299db097.png";